export default __webpack_public_path__ + "static/media/check_circle_default.53d5fdb6.svg";